module.exports = __webpack_public_path__ + "img/taxonomy-table.a2607a40.png";